<script setup lang="ts">

import {useBrowserInfoDumper} from "~/composables/useBrowserInfoDumper"
import {useApp} from "~/composables/useApp"
import ChatsButton from "~/components/ChatsButton.vue";

await useApp().load()

useBrowserInfoDumper().dump()

const fluid = computed<boolean>(() => Boolean(useRoute().meta['fluid'] ?? false))
const omitContainer = computed<boolean>(() => Boolean(useRoute().meta['omitContainer'] ?? false))
const disableChatsButton = computed<boolean>(() => Boolean(useRoute().meta['disableChatsButton'] ?? false))

onUnmounted(() => {
  useApp().unload()
})
</script>

<template>
  <v-app>
    <AppHeader/>
    <v-main>
      <template v-if="omitContainer">
        <slot/>
      </template>
      <template v-else>
        <v-container :fluid="fluid">
          <slot/>
        </v-container>
      </template>
      <ChatsButton v-if="!disableChatsButton" />
    </v-main>
  </v-app>
</template>

<style>
.v-breadcrumbs.v-breadcrumbs--density-compact {
  padding-top: 0;
  padding-bottom: 12px;
}

.panel-with-cards .v-expansion-panel-text {
  background-color: rgb(var(--v-theme-panels-with-cards))
}

.v-theme--light .panel-with-cards .v-expansion-panel-title.v-expansion-panel-title--active {
  background-color: rgb(var(--v-theme-panels-with-cards))
}
</style>